import React from 'react';
import UploadProgressBar from 'Data/components/UploadProgressBar';
import { Wrapper } from './ETLProgress.styles';

const ETLProgress = ({ statusMessage, progressStep }) => {
	return (
		<Wrapper>
			<UploadProgressBar
				label={statusMessage}
				value={progressStep}
				etl={true}
			/>
		</Wrapper>
	);
};

export default ETLProgress;
